import controller from './support.controller';
import template from './support.pug';

const SupportComponent = {
  controller,
  template,
};

export default SupportComponent;



// WEBPACK FOOTER //
// ./client/app/settings/support/support.component.js